<template>
    <section class="menu__page line-menu" v-if="loaded">
        <div class="item" v-if="menuTop" v-for="menu in menuTop" :key="menu.id">
            <nuxt-link :to="menu.link" class="solid-hover" exact>{{menu.name}}</nuxt-link>
        </div>
    </section>
</template>

<script>
    import RouteMixin from "../shared/mixins/RouteMixin";

    export default {
      mixins: [RouteMixin],
      computed: {
         loaded() {
            return this.$store.state.menu.menuItems.top.loaded
         },
         menuTop() {
            return this.$store.getters['menu/menuTop'](this.urlParent(this.$route.path)) || [];
         },
      },
      mounted() {
      },
      watch: {
        menuTop(menuItem) {
          if(menuItem.length) {
            const url = this.urlParentSub(this.$route.path) || null;
            const value = menuItem.find((item)=>item.link === url);
            this.$emit('currentMenu', value);
          }
        }
      }
    }
</script>

<style lang="scss" scoped>
    .menu__page {
        justify-content: space-between; -ms-flex-pack: justify;
        width: 55%;
        margin: 0 auto;
        padding-bottom: 100px;
        .item {
            padding-right: 5px;
            &:last-child {
                padding-right: 0px;
            }
        }

        @media (max-width: $media_sm) {
            width: 100%;
            padding-top: 0px;
            justify-content: space-evenly;
            padding-bottom: 40px;
        }
        @media (max-width: $media_xs) {
            padding-bottom: 20px;
        }
    }
</style>



// WEBPACK FOOTER //
// components/about/AboutMenu.vue